export const buttonStyle = {
    active: 'bg-[#1d2736] text-[#2283f6] hover:bg-[rgba(255,255,255,0.1)]',
    inactive: 'bg-[#161f2c] text-[#55657e] hover:bg-[rgba(255,255,255,0.1)]',
};

export const errorStyle = 'text-error text-xs pl-4 font-medium';
